import { useState } from 'react'
import EditBillModal from 'pages/Modals/EditBillModal'
import { MdCurrencyExchange  } from 'react-icons/md'
import { FaEye } from 'react-icons/fa'
import ReactTooltip from 'react-tooltip'
import { DateTime } from 'luxon'

import {
  Container,
  SubTitle,
  InfoText,
  InfoLink,
  Label,
  Button,
  Row
} from './styles'

export default function CustomerService ({
  data: service,
  onClick: handleClick,
  onEdit: handleChangeService
}) {
  const { bundle, loyalty_card, bill } = service
  const [showEditBillModal, setShowEditBillModal] = useState (false)
  
  const toggleEditBillModal = () => setShowEditBillModal (!showEditBillModal) 

  return (
    <>
      <Container>
        <SubTitle>
          {service.name}
        </SubTitle>
        {!!bundle ? (
          <InfoText>
            {bundle.name}
          </InfoText>
        ) : (
          <InfoText>
            {loyalty_card?.name}
          </InfoText>
        )}
        {bill ? (
          <InfoLink onClick={() => toggleEditBillModal ()}>
            <InfoText>
              Nº{bill?.number} ({DateTime.fromISO (bill?.date).toFormat ('dd/MM/yyyy')})
            </InfoText>
          </InfoLink>
        ) : (
          <InfoText>-</InfoText>
        )}
        <InfoText>
          {service.total_amount}
        </InfoText>
        <InfoText>
          {service.total_amount - service.available_amount}
        </InfoText>
        <InfoText>
          {service.available_amount}
        </InfoText>
        <InfoText>
          {service.expires_at
            ? DateTime.fromISO (service.expires_at).toFormat ('dd/MM/yyyy')
            : 'Indeterminado'
          }
        </InfoText>
        <Row>
          <Button onClick={() => handleClick (service)}>
            <FaEye color='#35A7FF' size={18}/>
          </Button>
          {service.available_amount > 0 && (
            <Button
              onClick={() => handleChangeService (service)}
              data-for={`${service.id}_exchange`}
              data-tip
            >
              <MdCurrencyExchange color='#FFC100' size={20}/>
            </Button>
          )}
        </Row>
        <ReactTooltip
          id={`${service.id}_exchange`}
          effect='solid'
          place='top'
          backgroundColor='#252525'
          tooltipRadius='10'
        >
          <Label style={{color: '#FFFFFF'}}>
            Trocar serviços
          </Label>
        </ReactTooltip>
      </Container>
      {bill && (
        <EditBillModal
          visible={showEditBillModal}
          data={bill}
          onClose={toggleEditBillModal}
        />
      )}
    </>
  )
}
